import { JobOpeningIcon } from "../assets/svg/JobOpening";
import { DescriptionIcon } from "../assets/svg/DescriptionIcon";

export const panelColumns = [
    {
      id: 1,
      panelName: "John Doe",
      skills: "React.js",
      availability: 2,
      totalExprience:"4",
    },
    {
      id: 2,
      panelName: "Jane Smith",
      skills: "Node.js",
      availability: 2,
      totalExprience:"4",
    },
    {
      id: 3,
      panelName: "Alice Johnson",
      skills: "Java",
      availability: 2,
      totalExprience:"4",
    },
  ];
  
  export const allSkills = [
    "Python", "Amazon DynamoDB", "GraphQL", "RESTful Architecture",
    "Amazon Web Services", "GitHub", "Serverless Computing",
    "Node.js", "Electron", "React", "Vue.js", "Cloud Architecture",
    "AWS CloudFormation", "Microsoft Azure", "TypeScript", "Docker",
    "Kubernetes", "CI/CD", "Jenkins", "Terraform"
  ];
  export const timeSlots = [
  { label: "10:00 AM - 12:00 PM", value: "10am-12pm" },
  { label: "12:00 PM - 2:00 PM", value: "12pm-2pm" },
  { label: "2:00 PM - 4:00 PM", value: "2pm-4pm" },
  { label: "4:00 PM - 6:00 PM", value: "4pm-6pm" },
];
export const totalExperienceOptions = [
  { value: "0-1", label: "0-1 years" },
  { value: "1-3", label: "1-3 years" },
  { value: "3-5", label: "3-5 years" },
  { value: "5+", label: "5+ years" },
];
export const panelTabs = [
       { label: 'Panel Details', Icon: JobOpeningIcon },
]

export const location = ["Noida","Gurgaon","USA","Bangloare"]
export const totalExperience = ["3","5","6","7"]
export const noiticPeriod = ["1 month","15 days","immediate Joiner"]
export const status = ["Hired","Rejected","Pending"]
export const applicationSource = ["Naukari","shine","linkedin"]
